import { DETAIL_PAGE_ACTIONS } from "../actions/actionTypes";

const initialState = {
  detailHomeSectionData: null,
  railData: null,
  relatedRailVodData: null,
  relatedRailData: null,
  videoId: null,
  playingVideo: null,
  isDetailHomeSectionLoading: false,
  isRailDataLoading: false,
  isRelatedRailDataLoading: false
};

export default function(state = initialState, action) {
  const { data } = action.payload || {};
  switch (action.type) {
    case DETAIL_PAGE_ACTIONS.RESET:
      return {
        ...state,
        detailHomeSectionData: null,
        railData: null,
        relatedRailVodData: null,
        relatedRailData: null,
        videoId: null,
        playingVideo: null
      };
    case DETAIL_PAGE_ACTIONS.SET_PLAYING_VIDEO:
      return {
        ...state,
        playingVideo: data
      };
    case DETAIL_PAGE_ACTIONS.HOME_PAGE_SECTION._START:
      return {
        ...state,
        detailHomeSectionData: null,
        isDetailHomeSectionLoading: true
      };
    case DETAIL_PAGE_ACTIONS.HOME_PAGE_SECTION._SUCCESS:
      return {
        ...state,
        detailHomeSectionData: data,
        isDetailHomeSectionLoading: false
      };
    case DETAIL_PAGE_ACTIONS.HOME_PAGE_SECTION._FAILURE:
      return {
        ...state,
        detailHomeSectionData: null,
        isDetailHomeSectionLoading: false
      };
    case DETAIL_PAGE_ACTIONS.RAIL._START:
      return {
        ...state,
        railData: null,
        isRailDataLoading: true
      };
    case DETAIL_PAGE_ACTIONS.RAIL._SUCCESS:
      return {
        ...state,
        railData: data,
        videoId: action.payload.videoId,
        isRailDataLoading: false
      };
    case DETAIL_PAGE_ACTIONS.RAIL._FAILURE:
      return {
        ...state,
        railData: null,
        isRailDataLoading: false
      };
    case DETAIL_PAGE_ACTIONS.RELATED_TOPIC_RAIL._START:
      return {
        ...state,
        relatedRailData: null,
        isRelatedRailDataLoading: true
      };
    case DETAIL_PAGE_ACTIONS.RELATED_TOPIC_RAIL._SUCCESS:
      return {
        ...state,
        relatedRailData: data,
        relatedRailVodData: action.payload.vodData,
        videoId: action.payload.videoId,
        isRelatedRailDataLoading: false
      };
    case DETAIL_PAGE_ACTIONS.RELATED_TOPIC_RAIL._FAILURE:
      return {
        ...state,
        relatedRailData: null,
        isRelatedRailDataLoading: false
      };
    default:
      return state;
  }
}
